import { useAPIRoute } from '../../hooks';
import { useQuery } from 'react-query';
import { WidgetConfigResponse } from 'rwl-shared/dist/models';

type UseFetchConfigParams = {
    accountId: string;
    enabled?: boolean;
};

export const useFetchConfig = ({
    accountId,
    enabled = true,
}: UseFetchConfigParams) => {
    const url = useAPIRoute('config', 'v1');

    return useQuery<WidgetConfigResponse>(
        ['config', accountId],
        async () => {
            try {
                const result = await fetch(
                    `${url}?` + new URLSearchParams({ accountId: accountId }),
                    {
                        method: 'GET',
                    }
                );
                return result.json();
            } catch (e) {
                console.error('useFetchConfig error:', e);
                throw e;
            }
        },
        {
            // CoPilot suggested these, lets see if we like them
            enabled,
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
        }
    );
};
